var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 27.957 22.352",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    strokeWidth: 0
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.946 11.352c0.8284 0 1.5 0.6716 1.5 1.5v4.8791l2.5629-2.0504c0.6469-0.5175 1.5908-0.4126 2.1084 0.2343 0.5175 0.6469 0.4126 1.5908-0.2343 2.1083l-5 4c-0.5478 0.4383-1.3263 0.4383-1.8741 0l-5-4c-0.6469-0.5175-0.7518-1.4614-0.2342-2.1083 0.5175-0.6469 1.4614-0.7518 2.1083-0.2343l2.563 2.0504v-4.8791c0-0.8284 0.6715-1.5 1.5-1.5z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m5.709 5.5508c-1.5668 0-2.5496 1.049-3.1445 1.6523-0.59489 0.60332-0.8023 0.75977-1.0059 0.75977a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5c1.5668 0 2.5477-1.049 3.1426-1.6523 0.59489-0.60332 0.80425-0.75976 1.0078-0.75976 0.20356 0 0.41097 0.15644 1.0059 0.75976 0.59489 0.60332 1.5758 1.6523 3.1426 1.6523s2.5496-1.049 3.1445-1.6523 0.8023-0.75976 1.0059-0.75976c0.20356 0 0.41293 0.15644 1.0078 0.75976s1.5758 1.6523 3.1426 1.6523 2.5477-1.049 3.1426-1.6523 0.80425-0.75976 1.0078-0.75976c0.20356 0 0.41097 0.15644 1.0059 0.75976s1.5758 1.6523 3.1426 1.6523a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5c-0.20356 0-0.41097-0.15644-1.0059-0.75977-0.59489-0.60332-1.5758-1.6523-3.1426-1.6523-1.5668-1e-6 -2.5496 1.049-3.1445 1.6523-0.59489 0.60333-0.8023 0.75977-1.0059 0.75977s-0.41292-0.15644-1.0078-0.75977c-0.59489-0.60332-1.5758-1.6523-3.1426-1.6523s-2.5477 1.049-3.1426 1.6523c-0.59489 0.60332-0.80425 0.75977-1.0078 0.75977-0.20356 0-0.41097-0.15644-1.0059-0.75977-0.59489-0.60332-1.5758-1.6523-3.1426-1.6523z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.6504 0c-1.5668 0-2.5496 1.049-3.1445 1.6523-0.59489 0.60332-0.8023 0.75977-1.0059 0.75977a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5c1.5668 0 2.5477-1.049 3.1426-1.6523 0.59489-0.60332 0.80425-0.75977 1.0078-0.75976 0.20356-1e-6 0.41097 0.15644 1.0059 0.75976s1.5758 1.6523 3.1426 1.6523 2.5496-1.049 3.1445-1.6523 0.8023-0.75977 1.0059-0.75976c0.20356 0 0.41293 0.15644 1.0078 0.75976s1.5758 1.6523 3.1426 1.6523 2.5477-1.049 3.1426-1.6523 0.80425-0.75977 1.0078-0.75976c0.20356 0 0.41097 0.15644 1.0059 0.75976s1.5758 1.6523 3.1426 1.6523a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5c-0.20356 0-0.41097-0.15644-1.0059-0.75977-0.59489-0.60332-1.5758-1.6523-3.1426-1.6523-1.5668-9e-7 -2.5496 1.049-3.1445 1.6523-0.59489 0.60332-0.8023 0.75977-1.0059 0.75977-0.20356 0-0.41292-0.15644-1.0078-0.75977-0.59489-0.60332-1.5758-1.6523-3.1426-1.6523s-2.5477 1.049-3.1426 1.6523c-0.59489 0.60332-0.80425 0.75977-1.0078 0.75977-0.20356 0-0.41097-0.15644-1.0059-0.75977-0.59489-0.60332-1.5758-1.6523-3.1426-1.6523z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDepth);
export default __webpack_public_path__ + "static/media/water_depth.8dbd7ccd152340d4b5b1f1faf781ec12.svg";
export { ForwardRef as ReactComponent };